import type { SxProps, Theme } from '@mui/material/styles';
import { APP_SHAPE } from './colors';

export { APP_SHAPE };

/** Shared button metrics — keep page-level `sx` overrides minimal. */
export const APP_BUTTON_SX: SxProps<Theme> = {
  textTransform: 'none',
  fontWeight: 600,
  borderRadius: `${APP_SHAPE.radiusMd}px`,
  px: 2,
  py: 1,
};

/**
 * Bordered surface (no shadow). Use for nested/inset panels.
 */
export const borderedSurfaceSx = (theme: Theme) => ({
  borderRadius: `${APP_SHAPE.radiusMd}px`,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: 'none',
  bgcolor: theme.palette.background.paper,
});

/** Elevated data panel — tables, lists, notification feeds. */
export const elevatedPanelSx: SxProps<Theme> = {
  borderRadius: `${APP_SHAPE.radiusLg}px`,
  overflow: 'hidden',
};

/** Bordered data panel — legacy flat tables (prefer elevatedPanelSx). */
export const pagePanelSx = (theme: Theme) => ({
  ...borderedSurfaceSx(theme),
  overflow: 'hidden' as const,
});
